export const APP_EXCLUDE_FROM_FAKEDOOR_EXPERIMENT = 'APP_EXCLUDE_FROM_FAKEDOOR_EXPERIMENT';
export const APP_INVOICE_LEVEL_FASTPAY_FAKEDOOR = 'APP_INVOICE_LEVEL_FASTPAY_FAKEDOOR';
export const APP_CUSTOMER_REVIEW_SUMMARY_PULL_FROM_DB = 'APP_CUSTOMER_REVIEW_SUMMARY_PULL_FROM_DB';
export const APP_EQUIPMENT_TROUBLESHOOTING = 'APP_EQUIPMENT_TROUBLESHOOTING';
export const APP_AUTH_MFA = 'APP_AUTH_MFA';
export const APP_AUTH_PASSKEY = 'APP_AUTH_PASSKEY';
export const APP_INVENTORY_MANAGEMENT = 'APP_INVENTORY_MANAGEMENT';
export const APP_DEVELOPER_CENTER = 'APP_DEVELOPER_CENTER';
export const APP_ORGANIZATION_API_KEYS = 'APP_ORGANIZATION_API_KEYS';
export const ACTIVATE_LENDING_MODULE = 'ACTIVATE_LENDING_MODULE';
export const AUTOBOTS_CALENDAR_VIEW = 'AUTOBOTS_CALENDAR_VIEW';
export const AUTOBOTS_SENSOR_DATA_EXPORTS = 'AUTOBOTS_SENSOR_DATA_EXPORTS';
export const AUTOBOTS_STAFF_SCHEDULE = 'AUTOBOTS_STAFF_SCHEDULE';
export const AUTOBOTS_VENDORS_CREATE_WORK_ORDERS = 'AUTOBOTS_VENDORS_CREATE_WORK_ORDERS';
export const CONFIRM_CONTACT_INFO = 'CONFIRM_CONTACT_INFO';
export const CORE_MARKET = 'CORE_MARKET';
export const DIRECT_ASSIGNMENT = 'DIRECT_ASSIGNMENT';
export const DISABLE_ISSUE_TREE = 'DISABLE_ISSUE_TREE';
export const KUSTOMER_HELP = 'KUSTOMER_HELP';
export const KUSTOMER_WORKORDER_ESCALATIONS = 'KUSTOMER_WORKORDER_ESCALATIONS';
export const NOTIFICATION_TEST_LIST = 'NOTIFICATION_TEST_LIST';
export const NOTES_REVAMP = 'NOTES_REVAMP';
export const STAFF_SELECT_HIDE_ADMIN = 'STAFF_SELECT_HIDE_ADMIN';
export const VENDOR_CUSTOMERS = 'VENDOR_CUSTOMERS';
export const VENDOR_TECHNICIAN_GPS_TRACKING = 'VENDOR_TECHNICIAN_GPS_TRACKING';
export const VENDOR_TECHNICIAN_SCHEDULE = 'VENDOR_TECHNICIAN_SCHEDULE';
export const VENDOR_AGENT_MD = 'VENDOR_AGENT_MD';
export const VENDOR_CLOSE_WITHOUT_CHARGE = 'VENDOR_CLOSE_WITHOUT_CHARGE';
export const VENDOR_CUSTOMER_GUIDANCE = 'VENDOR_CUSTOMER_GUIDANCE';
export const VENDOR_HIDE_OFF_RESQ_CUSTOMER_CREATION = 'VENDOR_HIDE_OFF_RESQ_CUSTOMER_CREATION';
export const VENDOR_REPORTING = 'VENDOR_REPORTING';
export const VENDOR_SLA = 'VENDOR_SLA';
export const VENDOR_SOURCING_PARTS_ETA = 'VENDOR_SOURCING_PARTS_ETA';
export const VENDOR_RESOLVE_INVOICE_DISPUTES = 'VENDOR_RESOLVE_INVOICE_DISPUTES';
export const VENDOR_ON_MY_WAY = 'VENDOR_ON_MY_WAY';
export const VENDOR_PRICE_BOOK_LINE_ITEM_QUICK_ADD = 'VENDOR_PRICE_BOOK_LINE_ITEM_QUICK_ADD';
export const VENDOR_SHARED_INTERNAL_NOTES = 'VENDOR_SHARED_INTERNAL_NOTES';
export const VORTEX_SCHEDULE_PAYMENT = 'VORTEX_SCHEDULE_PAYMENT';
export const VULCAN_DISPATCH_TO_INVITED_VENDOR = 'VULCAN_DISPATCH_TO_INVITED_VENDOR';
export const VULCAN_FAST_PAY_INCENTIVE = 'VULCAN_FAST_PAY_INCENTIVE';
export const VULCAN_STORE_VENDOR_REMITTANCE_PDF = 'VULCAN_STORE_VENDOR_REMITTANCE_PDF';
export const VULCAN_VERIFIED_VENDOR = 'VULCAN_VERIFIED_VENDOR';
export const WORK_ORDER_REVIEWS_NOTIFICATION = 'WORK_ORDER_REVIEWS_NOTIFICATION';
export const WORK_ORDER_AI_INTELLIGENCE = 'WORK_ORDER_AI_INTELLIGENCE';
export const WORK_ORDER_AI_NOTE_REPLY_SUGGESTIONS = 'WORK_ORDER_AI_NOTE_REPLY_SUGGESTIONS';
export const VORTEX_INVOICE_SETS_PAGE = 'VORTEX_INVOICE_SETS_PAGE';
export const VULCAN_INVOICE_SET_DISPUTE = 'VULCAN_INVOICE_SET_DISPUTE';
export const VORTEX_CREDIT_CARD_FEE = 'VORTEX_CREDIT_CARD_FEE';
export const VORTEX_OFF_PLATFORM_PROCESSING_FEE = 'VORTEX_OFF_PLATFORM_PROCESSING_FEE';
export const VULCAN_AGING_REPORT = 'VULCAN_AGING_REPORT';
export const VORTEX_REVENUE_SHARE_INVOICE_LEVEL_FEES = 'VORTEX_REVENUE_SHARE_INVOICE_LEVEL_FEES';
export const APP_TEAM_PAYQ_UPSELL_BANNERS = 'APP_TEAM_PAYQ_UPSELL_BANNERS';
export const VORTEX_INVOICES_LITE = 'VORTEX_INVOICES_LITE';
export const MONEY_JUSTIFI_INTEGRATION = 'MONEY_JUSTIFI_INTEGRATION';
export const MONEY_CREDIT_CARD_FEE_EXEMPT_CLIENT_ORG = 'MONEY_CREDIT_CARD_FEE_EXEMPT_CLIENT_ORG';
export const CREDIT_CARD_FEE_NEW_ORGS_2026_04 = 'CREDIT_CARD_FEE_NEW_ORGS_2026_04';
export const MONEY_LATE_FEE_EXEMPT_CLIENT_ORG = 'MONEY_LATE_FEE_EXEMPT_CLIENT_ORG';
export const MONEY_LATE_FEE_EXCLUDED_FROM_VENDOR_ORG = 'MONEY_LATE_FEE_EXCLUDED_FROM_VENDOR_ORG';
export const STRIPE_MERCHANT_ACCOUNT = 'STRIPE_MERCHANT_ACCOUNT';
export const PAYQ_ENABLED_VENDOR_ORG = 'PAYQ_ENABLED_VENDOR_ORG';
export const PMC_GROWTH_SCORE_POPUP = 'PMC_GROWTH_SCORE_POPUP';
export const APP_TEAM_VENDOR_RECOMMENDED_WORK_ORDERS = 'APP_TEAM_VENDOR_RECOMMENDED_WORK_ORDERS';
export const APP_TEAM_SAVINGS_OPPORTUNITY_CARD = 'APP_TEAM_SAVINGS_OPPORTUNITY_CARD';
export const APP_TEAM_CYOV_WARRANTY_CHANGES = 'APP_TEAM_CYOV_WARRANTY_CHANGES';
export const APP_TEAM_SHOW_CLIENT_REMITTANCE_PDF = 'APP_TEAM_SHOW_CLIENT_REMITTANCE_PDF';
export const APP_TEAM_ENABLE_QUICKBOOKS_INTEGRATION = 'APP_TEAM_ENABLE_QUICKBOOKS_INTEGRATION';
export const SENSORS_DISABLED_ALERTS = 'SENSORS_DISABLED_ALERTS';
export const FPIC_COMBINED_FACILITY = 'FPIC_COMBINED_FACILITY';
export const FP_VALUE_COMMS = 'FP_VALUE_COMMS';
export const IMMEDIATE_VENDOR_AGREEMENT_CHANGE = 'IMMEDIATE_VENDOR_AGREEMENT_CHANGE';
export const APP_TEAM_AUTOMATED_BULK_UPLOADS = 'APP_TEAM_AUTOMATED_BULK_UPLOADS';
export const APP_TEAM_ADJUST_WORK_ORDER_NTE_DURING_SUBMISSION =
    'APP_TEAM_ADJUST_WORK_ORDER_NTE_DURING_SUBMISSION';
export const RSG_CYOV_COMPARISON = 'RSG_CYOV_COMPARISON';
export const RSG_ACTION_CENTER = 'RSG_ACTION_CENTER';
export const RSG_ACTION_CENTER_DAILY_MENU = 'RSG_ACTION_CENTER_DAILY_MENU';
export const RSG_PARTNERED_FINANCIAL_TRANSCRIPTION_LEARNING =
    'RSG_PARTNERED_FINANCIAL_TRANSCRIPTION_LEARNING';
export const RSG_PROTECTION_PLAN = 'RSG_PROTECTION_PLAN';
export const PROTECTION_PLAN_LINE_ITEM_COVERAGE = 'PROTECTION_PLAN_LINE_ITEM_COVERAGE';
export const RSG_COMPLETION_REPORT = 'RSG_COMPLETION_REPORT';
export const RSG_OUTCOME_PRICING = 'RSG_OUTCOME_PRICING';
export const RSG_CUSTOMER_SENSORS = 'RSG_CUSTOMER_SENSORS';
export const SENSORS_V3_VIEWS = 'SENSORS_V3_VIEWS';
export const INVOICE_EXTRACTION_SUMMARY_MODAL = 'INVOICE_EXTRACTION_SUMMARY_MODAL';
export const RCC_MOVE_EQUIPMENT_TO_FACILITY = 'RCC_MOVE_EQUIPMENT_TO_FACILITY';
export const IWO_SPEND_TRACKING = 'IWO_SPEND_TRACKING';
export const IWO_STATUS_UPDATE = 'IWO_STATUS_UPDATE';
export const VENDOR_SUBCONTRACTING = 'VENDOR_SUBCONTRACTING';
export const VENDOR_TO_VENDOR_ESTIMATE_APPROVALS = 'VENDOR_TO_VENDOR_ESTIMATE_APPROVALS';
export const VENDOR_STANDALONE_ESTIMATE_WORK_ORDER_AUTOMATION =
    'VENDOR_STANDALONE_ESTIMATE_WORK_ORDER_AUTOMATION';
export const FAST_PAY_RATE_CHANGE_PHASE_1_COMMS = 'FAST_PAY_RATE_CHANGE_PHASE_1_COMMS';
export const FAST_PAY_RATE_POST_CHANGE_PHASE_1_COMMS = 'FAST_PAY_RATE_POST_CHANGE_PHASE_1_COMMS';
export const FAST_PAY_RATE_CHANGE_PHASE_2_COMMS = 'FAST_PAY_RATE_CHANGE_PHASE_2_COMMS';
export const FAST_PAY_RATE_POST_CHANGE_PHASE_2_COMMS = 'FAST_PAY_RATE_POST_CHANGE_PHASE_2_COMMS';
export const VENDOR_BUSINESS_PROFILE = 'VENDOR_BUSINESS_PROFILE';
export const VENDOR_INVOICE_ADDRESSES = 'VENDOR_INVOICE_ADDRESSES';
export const VENDOR_PROMOTIONS = 'VENDOR_PROMOTIONS';
export const VENDOR_SELF_SERVE_ONBOARDING_CHECKLIST = 'VENDOR_SELF_SERVE_ONBOARDING_CHECKLIST';
export const VENDOR_TOS_RECONFIRM_DEADLINE = 'VENDOR_TOS_RECONFIRM_DEADLINE';
export const VENDOR_WEBSITE_BUILDER_SURVEY = 'VENDOR_WEBSITE_BUILDER_SURVEY';
export const GOOGLE_ADS = 'GOOGLE_ADS';
export const PRINT_MARKETING = 'PRINT_MARKETING';
export const TRADES_MONETISATION = 'TRADES_MONETISATION';
export const RMC_NETWORK_DIRECTORY = 'RMC_NETWORK_DIRECTORY';
export const RMC_CREATE_FACILITIES = 'RMC_CREATE_FACILITIES';
export const COMMAND_PALETTE = 'COMMAND_PALETTE';
export const RCC_SENSOR_BULK_UPDATE_RANGES = 'RCC_SENSOR_BULK_UPDATE_RANGES';
export const NORA_INTEGRATION_V1 = 'NORA_INTEGRATION_V1';
export const NORA_CONFIGURATION_INTERVIEW_CALLS = 'NORA_CONFIGURATION_INTERVIEW_CALLS';
export const NORA_GOOGLE_EMAIL_AUTH = 'NORA_GOOGLE_EMAIL_AUTH';
export const NORA_GOOGLE_BUSINESS_AUTH = 'NORA_GOOGLE_BUSINESS_AUTH';
export const NORA_MAILBOX_OAUTH = 'NORA_MAILBOX_OAUTH';
export const RMC_DISPATCH_ORDER = 'RMC_DISPATCH_ORDER';
export const VENDOR_EQUIPMENT_CAPABILITY = 'VENDOR_EQUIPMENT_CAPABILITY';
export const VENDOR_EQUIPMENT_WARRANTY_SEARCH = 'VENDOR_EQUIPMENT_WARRANTY_SEARCH';
export const EQUIPMENT_VENDOR_DISPATCH_ORDER = 'EQUIPMENT_VENDOR_DISPATCH_ORDER';
export const WORK_ORDER_CREATE_FROM_VENDOR_RANKING = 'WORK_ORDER_CREATE_FROM_VENDOR_RANKING';
export const VENDOR_GROWTH = 'VENDOR_GROWTH';
export const VENDOR_INBOX = 'VENDOR_INBOX';
export const VENDOR_MARKET_RATE_OVERRIDES = 'VENDOR_MARKET_RATE_OVERRIDES';
export const VENDOR_PIN_WORK_ORDERS = 'VENDOR_PIN_WORK_ORDERS';
export const VENDOR_WORK_ORDER_REMINDERS = 'VENDOR_WORK_ORDER_REMINDERS';
export const VERIFY_PAYMENT_METHOD_MODAL = 'VERIFY_PAYMENT_METHOD_MODAL';
export const NORA_SMS_UPDATES = 'NORA_SMS_UPDATES';
export const TEMPORARILY_ALLOW_PAYMENT_METHOD_CHOICE = 'TEMPORARILY_ALLOW_PAYMENT_METHOD_CHOICE';
export const MANUAL_ACH_INPUT = 'MANUAL_ACH_INPUT';
export const VENDOR_RANKING_DISPATCH = 'VENDOR_RANKING_DISPATCH';
export const VENDOR_RANKING_DISPATCH_ENABLED_ORGS = 'VENDOR_RANKING_DISPATCH_ENABLED_ORGS';
export const SCHEDULE_OFF_RESQ_WORK_ORDER = 'SCHEDULE_OFF_RESQ_WORK_ORDER';
export const VISIT_NOTES_AI = 'VISIT_NOTES_AI';
export const SUBCONTRACT_REQUIRED_VISIT_DOCUMENTATION = 'SUBCONTRACT_REQUIRED_VISIT_DOCUMENTATION';
export const VENDOR_VISIT_EQUIPMENT_DOCUMENTATION = 'VENDOR_VISIT_EQUIPMENT_DOCUMENTATION';
export const SHOW_NORA_MESSAGES = 'SHOW_NORA_MESSAGES';
export const OFF_RESQ_INVOICES = 'OFF_RESQ_INVOICES';
export const USER_BASED_PRICING = 'USER_BASED_PRICING';
export const RMC_ASSISTANT_DRAWER = 'RMC_ASSISTANT_DRAWER';
export const NORA_NOTIFICATIONS = 'NORA_NOTIFICATIONS';
export const VENDOR_WEBSITE = 'VENDOR_WEBSITE';
export const VENDOR_WEBSITE_EXTERNAL_FORMS = 'VENDOR_WEBSITE_EXTERNAL_FORMS';
export const VENDOR_MAIL_INSIGHTS = 'VENDOR_MAIL_INSIGHTS';
export const SUBCONTRACT_VENDOR_AGREEMENT_INVOICES = 'SUBCONTRACT_VENDOR_AGREEMENT_INVOICES';
export const SUBCONTRACTOR_SHARE_TIERS = 'SUBCONTRACTOR_SHARE_TIERS';
export const TRADES_CUSTOMER_INVOICES = 'TRADES_CUSTOMER_INVOICES';
export const RSG_BASIC_CUSTOMER_MIGRATION = 'RSG_BASIC_CUSTOMER_MIGRATION';
